module.exports = __webpack_public_path__ + "static/media/GB.db68882c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GB.svg
// module id = 2155
// module chunks = 7